$(document).ready(function() {

    function getContainerHeightLimit(container) {
        return container.attr('data-height') || 300;
    }

    function shrinkContainer(container) {

        // determine height limit for container
        var heightLimit = getContainerHeightLimit(container);

        // remove expanded class
        container.removeClass('readmorejs-expanded');

        // set max height of container
        container.css('overflow', 'hidden');
        container.css('max-height', heightLimit + 'px');
        container.css('-webkit-mask-image', 'linear-gradient(180deg, #000 90%, transparent)');

    }

    function expandContainer(container) {

        // add expanded class
        container.addClass('readmorejs-expanded');

        // set container to full size
        container.css('overflow', '');
        container.css('max-height', '');
        container.css('-webkit-mask-image', '');

    }

    // shrink readmore containers if they exceed height limit
    window.initReadMoreJs = function() {
        $('.readmorejs').each(function() {

            var container = $(this);
            var heightLimit = getContainerHeightLimit(container);

            // do nothing if height less than limit
            if(container.height() <= heightLimit){
                return;
            }

            // do nothing if toggle already added
            var parent = container.parent();
            if(parent.find('.readmorejs-toggle').length > 0){
                return;
            }

            // add toggle button
            parent.append($('<a href="javascript:void(0);" class="readmorejs-toggle">Show More</a>'));

            // shrink container since it's over limit
            shrinkContainer(container);

        });
    }

    // toggle between short and full text in readmore containers
    document.addEventListener('click', function(event) {
        if(event.target && event.target.classList.contains('readmorejs-toggle')){

            // prevent scroll to top
            event.preventDefault();

            // find elements
            var toggleButton = $(event.target);
            var container = toggleButton.parent().find('.readmorejs');

            if(container.hasClass("readmorejs-expanded")){
                shrinkContainer(container);
                toggleButton.html('Show More');
            } else {
                expandContainer(container);
                toggleButton.html('Show Less');
            }

        }
    });

    window.initReadMoreJs();

});
